import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  CarsCarousel,
  FinanceOfferCardBlock,
  GridRows,
} from '../molecule-blocks'

export const moleculeStoryblokComponents: ComponentMap = {
  CarsCarousel,
  FinanceOfferCard: FinanceOfferCardBlock,
  GridRows,
}
